import Vue from 'vue'
import App from './App.vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import VueRouter from 'vue-router'
import CompareDocTaskList from './views/CompareDoc/TaskList.vue'
import CompareDocNewTask from './views/CompareDoc/NewTask.vue'
import CompareDocTaskResult from './views/CompareDoc/TaskResult.vue'
import AuditReportTaskList from './views/AuditReport/TaskList.vue'
import AuditReportNewTask from './views/AuditReport/NewTask.vue'
import AuditReportTaskResult from './views/AuditReport/TaskResult.vue'
import BankStatementTaskList from './views/BankStatement/TaskList.vue'
import BankStatementNewTask from './views/BankStatement/NewTask.vue'
import BankStatementTaskResult from './views/BankStatement/TaskResult.vue'
import EditTaskData from '@/components/EditTaskData.vue'
import FinancialDocumentTaskList from './views/FinancialDocument/TaskList.vue'
import FinancialDocumentNewTask from './views/FinancialDocument/NewTask.vue'
import FinancialDocumentTaskResult from './views/FinancialDocument/TaskResult.vue'

import NewCompany from './views/Company/NewCompany.vue'
import CompanyList from './views/Company/CompanyList.vue'
import CompanyDetails from './views/Company/CompanyDetails.vue'

import CompanyHeader from './components/Header/CompanyHeader.vue';
import TaskHeader from './components/Header/TaskHeader.vue';
import CompareDocHeader from './components/Header/CompareDocHeader.vue';

import axios from 'axios'
import '@mdi/font/css/materialdesignicons.min.css';

Vue.use(Vuetify)
Vue.use(VueRouter)

const baseUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:8001' : ''
Vue.prototype.$http = axios.create({
  baseURL: baseUrl
})

const routes = [
  { path: '/compare_doc/tasks', name: 'CompareDocTaskList', component: CompareDocTaskList, meta: { headerComponent: CompareDocHeader } },
  { path: '/compare_doc/new-task', component: CompareDocNewTask, meta: { headerComponent: CompareDocHeader } },
  { path: '/compare_doc/task-result', name: 'CompareDocTaskResult', component: CompareDocTaskResult, meta: { headerComponent: CompareDocHeader } },
  { path: '/compare_doc/edit-task-data', name: 'CompareDocEditTaskData', component: EditTaskData, meta: { headerComponent: CompareDocHeader } },
  { path: '/audit_report/tasks', name: 'AuditReportTaskList', component: AuditReportTaskList, meta: { headerComponent: TaskHeader } },
  { path: '/audit_report/new-task', component: AuditReportNewTask, meta: { headerComponent: TaskHeader } },
  { path: '/audit_report/task-result', name: 'AuditReportTaskResult', component: AuditReportTaskResult, meta: { headerComponent: TaskHeader } },
  { path: '/audit_report/edit-task-data', name: 'AuditReportEditTaskData', component: EditTaskData, meta: { headerComponent: TaskHeader } },
  { path: '/bank_statement/tasks', name: 'BankStatementTaskList', component: BankStatementTaskList, meta: { headerComponent: TaskHeader } },
  { path: '/bank_statement/new-task', component: BankStatementNewTask, meta: { headerComponent: TaskHeader } },
  { path: '/bank_statement/task-result', name: 'BankStatementTaskResult', component: BankStatementTaskResult, meta: { headerComponent: TaskHeader } },
  { path: '/bank_statement/edit-task-data', name: 'BankStatementEditTaskData', component: EditTaskData, meta: { headerComponent: TaskHeader } },
  { path: '/financial_document/tasks', name: 'FinancialDocumentTaskList', component: FinancialDocumentTaskList, meta: { headerComponent: TaskHeader } },
  { path: '/financial_document/new-task', component: FinancialDocumentNewTask, meta: { headerComponent: TaskHeader } },
  { path: '/financial_document/task-result', name: 'FinancialDocumentTaskResult', component: FinancialDocumentTaskResult, meta: { headerComponent: TaskHeader } },
  { path: '/financial_document/edit-task-data', name: 'FinancialDocumentEditTaskData', component: EditTaskData, meta: { headerComponent: TaskHeader } },

  { path: '/company/new', name: 'CreateCompany', component: NewCompany, meta: { headerComponent: CompanyHeader } },
  { path: '/company/list', name: 'CompanyList', component: CompanyList, meta: { headerComponent: CompanyHeader } },
  { path: '/company/:id', name: 'CompanyDetails', component: CompanyDetails, meta: { headerComponent: CompanyHeader } },
  { path: '/', redirect: '/tasks' }
]

const router = new VueRouter({
  mode: 'history', // Enable history mode
  base: process.env.BASE_URL || '/', // Set base URL (configurable via .env)
  routes
})

// Set the document title
document.title = 'Automation App';

new Vue({
  vuetify: new Vuetify(),
  router,
  render: h => h(App)
}).$mount('#app')
